// extracted by mini-css-extract-plugin
export default {"video":"youtube_video__QK5vK","video-container":"youtube_video-container__pjjP8"};